import { useState, useEffect } from 'react';
import {
    Container,
    Content,
    List,
    ContentPickList,
    Selected,
    AddContacts,
    Save
} from './styled';
import { toast } from 'react-toastify';
import {
    LoadingSpinner,
    Modal,
    Avatar,
    Search,
    PickList,
    Skeleton
} from '../../components';
import { BiChevronLeft, BiLinkExternal } from 'react-icons/bi';
import { IoSave, IoAddCircleOutline } from 'react-icons/io5';
import { RiContactsBook2Line } from 'react-icons/ri';
import { getFullClients } from '../../service/serviceChat/clientsService';
import {
    getTransmission,
    postTransmission,
    putTransmission,
    getContactsInTransmission,
    deleteContactInTransmission,
    creatContactInTransmission
} from '../../service/serviceChat/transmissionService';

export function TransmissionList(props) {
    const { back, soucerData, alowCreateList } = props;

    const [render, setRender] = useState(0);
    const [search, setSearch] = useState('');
    const [transmissionList, setTransmissionList] = useState([]);
    const [idList, setIdList] = useState(0);
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [contacts, setContacts] = useState([]);
    const [contactsSelected, setContactsSelected] = useState([]);
    const [currentContacts, setCurrentContacts] = useState([]);
    const [openAddContacts, setOpenAddContacts] = useState(false);
    const [loading, setLoading] = useState(false);
    const [searchInFrom, setSearchInFrom] = useState('');
    const [searchInTo, setSearchInTo] = useState('');

    const searchTransmissionList = async () => {
        setLoading(true)
        setTransmissionList(await getTransmission());
        setLoading(false)
    };
    useEffect(() => {
        if (soucerData) {
            setTransmissionList(soucerData);
        } else {
            searchTransmissionList();
        }
    }, []);
    const ItemTemplate = (props) => {
        const { item } = props;
        return (
            <ContentPickList>
                <div className='avatar--'>
                    <Avatar name={item?.name} width={'3rem'} height={'3rem'} fontSize={'1.5rem'} />
                </div>
                <div className='info--'>
                    <div className='name'>
                        <div className='name--'>
                            {item?.name}
                        </div>
                    </div>
                    <div className='description'>
                        {item?.number_client}
                    </div>
                </div>
            </ContentPickList>
        )
    };
    const reset = () => {
        setName('');
        setDescription('');
        setCurrentContacts([]);
        setContactsSelected([]);
        setLoading(false);
    };
    function onFilter(obj) {
        return obj?.nome?.toLowerCase()?.includes(search?.toLowerCase())
    };
    function onFilterInFrom(obj) {
        return obj?.name?.toLowerCase()?.includes(searchInFrom?.toLowerCase())
            || obj?.number_client?.toLowerCase()?.includes(searchInFrom?.toLowerCase());
    };
    function onFilterInTo(obj) {
        return obj?.name?.toLowerCase()?.includes(searchInTo?.toLowerCase())
            || obj?.number_client?.toLowerCase()?.includes(searchInTo?.toLowerCase());
    };
    async function newTransmissionList() {
        reset();
        setContacts(await getFullClients());
        setRender(1);
    };
    async function onSelect(item) {
        setLoading(true)
        setIdList(item.id);
        const fullContacts = await getFullClients();
        const dataTransmissionList = await getContactsInTransmission(item.id);
        if (!dataTransmissionList) {
            setLoading(false)
            return toast.error('Erro ao buscar detalhes da lista !', { position: "top-center", theme: "colored" });
        }
        setCurrentContacts([...dataTransmissionList])

        var result = [];
        dataTransmissionList?.forEach((item) => {
            var aux = fullContacts.find((obj) => { return obj.id === item.client_id });
            result.push(aux);
        });
        setContactsSelected([...result])

        result?.forEach((item) => {
            fullContacts.splice(fullContacts.indexOf(item), 1)
        });
        setContacts(fullContacts);

        setName(item?.nome);
        setDescription(item?.descricao ? item.descricao : '...');
        setLoading(false)
        setRender(2);
    };
    async function saveList() {
        setLoading(true)
        if (!name) {
            setLoading(false);
            return toast.warn('Por favor insira um nome !', { position: "top-center", theme: "colored" });
        }
        if (contactsSelected.length <= 0) {
            setLoading(false);
            return toast.warn('Por favor insira um contato !', { position: "top-center", theme: "colored" });
        }
        var dataList
        if (render === 1) {
            dataList = await postTransmission(name, description);
            if (!dataList) {
                setLoading(false)
                return toast.error('Erro ao Criado Lista !', { position: "top-center", theme: "colored" });
            }
        } else {
            dataList = await putTransmission(idList, name, description);
            if (!dataList) {
                setLoading(false);
                return toast.error('Erro ao Atualizar Lista !', { position: "top-center", theme: "colored" });
            }
        }
        currentContacts?.forEach(async (item) => {
            if (!contactsSelected.find((obj) => { return obj.id === item.client_id })) {
                await deleteContactInTransmission(dataList.id, item.id)
            }

        });
        contactsSelected?.forEach(async (item) => {
            if (!currentContacts.find((obj) => { return obj.client_id === item.id })) {
                await creatContactInTransmission(dataList.id, item.id)
            }
        });
        toast.success(`Lista ${render === 1 ? 'Criada' : 'Atualizada'} !`, { position: "top-center", theme: "colored" });
        reset();
        searchTransmissionList();
        setRender(0);
        return
    };
    const SkeletonRender = ({ count }) => {
        const skeletonArray = [];
        for (let i = 0; i < count; i++) {
            skeletonArray.push(<Skeleton type='contact' key={i} />);
        }
        return (
            <div>
                {skeletonArray}
            </div>
        );
    };

    return (
        <>
            <Container loading={loading ? 1 : 0}>
                {back && render === 0 &&
                    <span onClick={() => back()}>
                        <BiChevronLeft className='icon' />
                        VOLTAR
                    </span>
                }
                <Content back={back ? 1 : 0}>
                    {render === 0
                        ? <>
                            <span className='add--'>
                                {alowCreateList &&
                                    <label onClick={() => newTransmissionList()}>
                                        nova lista
                                        <IoAddCircleOutline />
                                    </label>
                                }
                            </span>
                            <Search
                                className="search"
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                            />
                            <List>
                                {loading && transmissionList.length < 0
                                    ? <SkeletonRender count={15} />
                                    : <>
                                        {transmissionList.length > 0
                                            &&
                                            transmissionList
                                                ?.filter(onFilter)
                                                ?.map((item) => {
                                                    return (
                                                        <li
                                                            key={item.id}
                                                            onClick={() => onSelect(item)}
                                                        >
                                                            <span className='avatar--'>
                                                                <span className='icon--'>
                                                                    <RiContactsBook2Line
                                                                        fontSize={'2rem'}
                                                                    />
                                                                </span>
                                                            </span>
                                                            <span className='info--'>
                                                                <span className='name'>
                                                                    <span
                                                                        className='name--overflow'
                                                                    >
                                                                        {item?.nome}
                                                                    </span>
                                                                </span>
                                                                <span
                                                                    className='description'
                                                                >
                                                                    {
                                                                        item?.descricao
                                                                            ? item.descricao
                                                                            : '...'
                                                                    }
                                                                </span>
                                                            </span>
                                                        </li>
                                                    )
                                                })

                                        }
                                    </>
                                }
                            </List>
                        </>
                        : <div className='list--options'>
                            <span
                                className='back--lists'
                                onClick={() => setRender(0)}
                            >
                                <BiChevronLeft className='icon' />
                                VOLTAR
                            </span>
                            <div className='box'>
                                <input
                                    placeholder='Nome'
                                    type="text"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    disabled={!alowCreateList}
                                />
                            </div>
                            <div className='box'>
                                <input
                                    placeholder='Descrição'
                                    type="text"
                                    value={description}
                                    onChange={
                                        (e) => setDescription(e.target.value)
                                    }
                                    disabled={!alowCreateList}
                                />
                            </div>
                            <div className='add--contacts'>
                                {contactsSelected?.length > 0 &&
                                    <div className='contacts--selecteds'>
                                        <span className='tag--'>
                                            <label>
                                                Contatos na Lista
                                            </label>
                                        </span>
                                        {
                                            contactsSelected?.map((item) => {
                                                return (
                                                    <Selected key={item.id}>
                                                        <label className='name'>
                                                            {item?.name}
                                                        </label>
                                                    </Selected>
                                                )
                                            })
                                        }
                                    </div>
                                }
                                {alowCreateList &&
                                    <button
                                        onClick={
                                            () => setOpenAddContacts(true)
                                        }
                                    >
                                        Adicionar Contatos
                                        <BiLinkExternal />
                                    </button>
                                }
                            </div>
                            {contactsSelected.length > 0 && alowCreateList &&
                                <Save loading={loading ? 1 : 0}>
                                    <button onClick={() => saveList()}>
                                        {loading
                                            ? <LoadingSpinner />
                                            : <>
                                                Salvar
                                                <IoSave />
                                            </>
                                        }
                                    </button>
                                </Save>
                            }
                        </div>
                    }
                </Content>
            </Container>
            <Modal
                isOpen={openAddContacts}
                close={() => setOpenAddContacts(false)}
            >
                <AddContacts>
                    {openAddContacts &&
                        <PickList
                            onFilterInFrom={onFilterInFrom}
                            onFilterInTo={onFilterInTo}
                            searchInFrom={searchInFrom}
                            setSearchInFrom={setSearchInFrom}
                            searchInTo={searchInTo}
                            setSearchInTo={setSearchInTo}
                            ItemTemplate={ItemTemplate}
                            identifier={'id'}
                            options={contacts}
                            setOptions={setContacts}
                            selecteds={contactsSelected}
                            setSelecteds={setContactsSelected}
                        />
                    }
                </AddContacts>
            </Modal>
        </>

    );
}